const triggerDropdown = (el) => {

    let dropdown = el.nextElementSibling
    
    el.classList.toggle('trigger')
    dropdown.classList.toggle('trigger')

    if (el.getAttribute('aria-expanded') === 'true')
        el.setAttribute('aria-expanded', 'false')
    else {
        el.setAttribute('aria-expanded', 'true')
    }
    
    // let focus = dropdown.querySelector('.dropdown-filter-opt-item:not(.trigger)')

    // if (!focus)
    
    // dropdown.querySelector('.dropdown-filter-opt-item:not(.trigger)').focus()
}

const blurDropdown = (el) => {

    let dropdownTrigger = document.querySelector('.dropdown-filter-trigger.trigger'),
        dropdown        = dropdownTrigger.nextElementSibling

    if (el === dropdownTrigger || el.classList.contains('dropdown-filter-opt-item')) return

    dropdownTrigger.classList.remove('trigger')
    dropdownTrigger.setAttribute('aria-expanded', 'false')
    dropdown.classList.remove('trigger')
}

const selectOpt = (el) => {

    let dropdownTrigger = document.querySelector('.dropdown-filter-trigger.trigger'),
        dropdown        = dropdownTrigger.nextElementSibling,
        input           = dropdown.parentElement.querySelector('.dropdown-filter-value')

    dropdownTrigger.innerHTML = el.innerHTML
    input.value = el.getAttribute('data-value')

    dropdownTrigger.classList.remove('trigger')
    dropdownTrigger.setAttribute('aria-expanded', 'false')
    dropdown.classList.remove('trigger')

    dropdown.querySelector('.trigger').classList.remove('trigger')
    el.classList.add('trigger')
}

export {
    triggerDropdown,
    blurDropdown,
    selectOpt
}